import './radioButton.scss';
import type {RadioButton_Listing_Numeric_Props} from "./RadioButton.interface";
import {Paragraph} from "../../Elements/Paragraph";
import {useTranslation} from "react-i18next";

/**
 * Primary UI component for user interaction
 */
export function ListingNumericRadioButton (props: RadioButton_Listing_Numeric_Props) {

    const {t} = useTranslation();

    const getLeadingWord = (index: number) => {
        if (index + 1 === 1) {
            return t('button.radio.listingNumeric.first');
        } else if (index + 1 === 2) {
            return t('button.radio.listingNumeric.second');
        } else if (index + 1 === 3) {
            return t('button.radio.listingNumeric.third');
        } else {
            return t('button.radio.listingNumeric.step');
        }
    };

    return (
        <div className={["radiobutton-wrapper", props.className, props.hide ? "hide" : "", props.recommended ? "highlight" : "no-highlight"].join(" ")}>
            {props.recommended &&
            <div className={"recommended"} onClick={props.onClick}>
                {t("button.recommended")}
            </div>
            }
            <div className="radiobutton-input-row" onClick={props.onClick}>
                <div className="input">
                    <input id={props.id} aria-label={props.id} readOnly type="radio" checked={props.selected}/>
                </div>
                <div>
                    <label htmlFor={props.id} aria-label={props.id}>
                        {props.label}
                    </label>
                </div>
            </div>
            {/*TODO refactor*/}
            {props.selected &&
                <div style={props.spacing===false?{marginTop:"20px"}: {}} className="radiobutton-content-row listing">
                    {props.steps.map((str, index) => {
                        return (
                            <div key={index}>{!(props.spacing===false) ? 
                                <div className="step">
                                    <Paragraph text={getLeadingWord(index)} className={"radiobutton-content-row tabulator strong"}/>
                                    <Paragraph text={str}/>
                                </div> 
                                : 
                                <div className="step">
                                    <Paragraph text={getLeadingWord(index)} className={"mainColor strong"}/>
                                    <Paragraph text={str} className="mainColor"/>
                                </div>
                            }
                            </div>
                        );
                    })}
                </div>
            }
        </div>
    );
}
